import img1 from "../../../Images/banner-black-phone.jpg";
import img2 from "../../../Images/banner-crimes-of-the-future.jpg";
import img3 from "../../../Images/banner-dragon-ball.jpg";
import img4 from "../../../Images/banner-elvis.jpg";
import img5 from "../../../Images/banner-nope.jpg";
import img6 from "../../../Images/banner-after-ever-happy.jpg";
import img7 from "../../../Images/banner-cronica-francesa.jpg";

const carrouselImg = [
  {
    image: img1,
    // url: "http://localhost:3000",
    alt: "banner image",
  },
  {
    image: img2,
    // url: "http://localhost:3000",
    alt: "banner image",
  },
  {
    image: img3,
    // url: "http://localhost:3000",
    alt: "banner image",
  },
  {
    image: img4,
    // url: "http://localhost:3000",
    alt: "banner image",
  },
  {
    image: img5,
    // url: "http://localhost:3000",
    alt: "banner image",
  },
  {
    image: img6,
    // url: "http://localhost:3000",
    alt: "banner image",
  },
  {
    image: img7,
    // url: "http://localhost:3000",
    alt: "banner image",
  },
];

export default carrouselImg;
